<!-- Start Main Banner Area -->
<div class="banner-section">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-12">
                        <div class="banner-content">
                            <span class="sub-title" >Ushering you to New Heights.</span>
                            <h1>bringing your business online</h1>
                            <p >We work hand-in-hand with industry-leading brands to help redefine the possibilities and potential of digital engagements.</p>
                            <form [formGroup]="contactForm" (ngSubmit)="getStarted()">
                                <input formControlName="email" type="email" class="input-newsletter" placeholder="your email address" name="EMAIL">
                                <button type="submit" >Get Started</button>
                            </form>
                            <p style="font-size: small;">* By entering your email, you agree to receive email from our marketing team</p>
                        </div>
                    </div>

                    <div class="col-lg-5 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/rocketnew.png" class="wow fadeInUp" data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/rocket-shape.png" class="wow fadeIn" data-wow-delay="1s" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="EWNS"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="EWNS"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="EWNS"></div>
    <div class="cloud-shape"><img src="assets/img/cloud-shape.png" alt="EWNS"></div>
    <div class="cloud-icon1"><img src="assets/img/cloud1.png" alt="EWNS"></div>
    <div class="cloud-icon2"><img src="assets/img/cloud2.png" alt="EWNS"></div>
    <div class="cloud-icon3"><img src="assets/img/cloud3.png" alt="EWNS"></div>
</div>
<!-- End Main Banner Area -->





<!-- Start Features Area -->
<app-digitaltrasform></app-digitaltrasform>
<!-- End Features Area -->




<!-- Start Fun Facts Area -->
<app-funfact></app-funfact>
<!-- End Fun Facts Area -->


<!-- Start Partner Area -->

<br/><br/>
<!-- app-banners></app-banners> -->


<!-- Start Team Area
<section class="team-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Our Team</span>
            <h2>Meet Our Core Team Members</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/team1.jpg" alt="team">
                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Raju Janagani</h3>
                        <span>Co Founder</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="https://ewnsassets.s3.ap-south-1.amazonaws.com/master/assets/img/ravi.jpg" alt="team">
                        <div class="social">
                            <a href="https://www.linkedin.com/in/naik899/" target="_blank"><i class="fab fa-linkedin"></i></a>
                            <a href="https://twitter.com/ravindranaik899" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="http://ravindranaik.com/" target="_blank"><i class="fab fa-wordpress"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Ravindra Naik</h3>
                        <span>VP of Product</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/img/team-image/team2.jpg" alt="team">
                        <div class="social">
                            <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
                            <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
                        </div>
                    </div>
                    <div class="content">
                        <h3>Vikas Pachori</h3>
                        <span>Architect</span>
                    </div>
                </div>
            </div>

           
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/shape6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</section>
<!-- End Team Area -->

<br/><br/>

<!-- Start Feedback Area -->
<section class="feedback-area ptb-100 bg-color">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Testimonials</span>
            <h2>Some Lovely Feedback From Our Clients</h2>
        </div>
    </div>

    <div class="feedback-slides owl-carousel owl-theme">
        <div class="single-feedback-item">
            <p>“We have seen a huge increase in the number of online contact forms being filled out and returned to us from the time we used EWNS. The end result was a website that is attractive, organized and effective. Thanks to EWNS for all of your hard work and support!”</p>
            <div class="client-info">
                
                <h3> Dr. Ajay</h3>
                <span>Sri Sai Dental Clinic</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“With EWNS's help, we were able to increase the functionality of our website dramatically while cutting our costs. Our website is much more easy to use and is incredibly easy to maintain. We could not be more happy with our new website! Thanks EWNS!”</p>
            <div class="client-info">
                <h3>Sondan Singh</h3>
                <span>Perfect Cabin</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“I would highly recommend EWNS. They are great to work with. I have gone through website redesigns before, and by far, this one was the easiest and least painful and most importantly traffic to our website has increased thanks to their SEO program.”</p>
            <div class="client-info">
                <h3>Dr. Kavitha Reddy</h3>
                <span>Kavitha Reddy Hospital</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“EWNS listened to everything we needed in a new website, then delivered it! Our new website is exciting & easy to use for me & our audiences. I have gone through website redesigns before, and by far, this one was the easiest and least painful.”</p>
            <div class="client-info">
                <h3>Electronic Bazar</h3>
                <span>HP Stores</span>
            </div>
        </div>

        <div class="single-feedback-item">
            <p>“We re-did our website twice in a 12 month period. There was no comparison between the first one and EWNS. Professional, Creative, Attentive to Detail, Excellent Communication. If I had contracted with EWNS the first time I would not have had to do it twice.”</p>
            <div class="client-info">
                <h3>Evoke Dental</h3>
                <span>Evoke Dental Care</span>
            </div>
        </div>
    </div>
</section>
<!-- End Feedback Area -->

<!-- Start Pricing Area -->
<section class="pricing-area ptb-100 pt-0">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Pricing Plan</span>
            <h2>Choose Your Best Plan</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box red">
                    <div class="pricing-header">
                        <h3>Basic</h3>
                    </div>
                    <div class="price">
                        <sub>₹</sub>
                        25,000
                        <sub>/Yr</sub>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i> 1 Email, Unlimited Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Onboarding Content Curation</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing (addon)</li>
                        <li><i class="flaticon-close"></i> Ecommerce</li>
                        <li><i class="flaticon-close"></i> Customize Theme </li>
                    </ul>
                    <a href="https://portal.ewns.in/signup" title="Get Started" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-pricing-box ">
                    <div class="pricing-header">
                        <h3>Premium</h3>
                    </div>
                    <div class="price">
                        <sub>₹</sub>
                        50,000
                        <sub>/yr</sub>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i> 3 Emails, Unlimited Web Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                      
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing (addon)</li>
                        <li><i class="flaticon-tick"></i> Ecommerce</li>
                       
                        <li><i class="flaticon-tick"></i> Customized Theme</li>
                    </ul>
                    <a href="https://portal.ewns.in/signup" title="Get Started" class="get-started-btn">Get Started</a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-pricing-box orange">
                    <div class="pricing-header">
                        <h3>Enterprise</h3>
                    </div>
                    <div >
                        <h2 style="font-size: 50px; font-weight: 700;">Talk to Us</h2>
                    </div>
                    <ul class="price-features-list">
                        <li><i class="flaticon-tick"></i> 1 Website</li>
                        <li><i class="flaticon-tick"></i>  Unlimited Web Hosting</li>
                        <li><i class="flaticon-tick"></i> SSL encryption</li>
                        <li><i class="flaticon-tick"></i> 99% Availability</li>
                        <li><i class="flaticon-tick"></i> Editorial Services</li>
                        <li><i class="flaticon-tick"></i> Content Management Portal</li>
                      
                        <li><i class="flaticon-tick"></i> Hyper Local SEO</li>
                        <li><i class="flaticon-tick"></i> Digital Marketing</li>
                        <li><i class="flaticon-tick"></i> Ecommerce</li>
                       
                        <li><i class="flaticon-tick"></i> Customization</li>
                    </ul>
                    <a routerLink="/contact" title="Contact us" class="get-started-btn">Contact Us</a>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img6"><img src="assets/img/shape/shape6.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</section>
<!-- End Pricing Area -->

<app-subscription></app-subscription>

<!-- Start Blog Area 
<section class="blog-area ptb-100 bg-F4F7FC">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Latest News</span>
            <h2>Our Latest Articles And News For Our Clients</h2>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog/"><img src="assets/img/blog-image/blog1.jpg" alt="image"></a>
                    </div>
                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a routerLink="/">Sarah Taylor</a></li>
                                <li>June 24, 2019</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/blog-details">How To Boost Your Digital Marketing Agency</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <a routerLink="/blog-details" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details"><img src="assets/img/blog-image/blog2.jpg" alt="image"></a>
                    </div>
                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a routerLink="/">James Anderson</a></li>
                                <li>June 26, 2019</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/blog-details">The Rise Of Smarketing And Why You Need It</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <a routerLink="/blog-details" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="single-blog-post">
                    <div class="post-image">
                        <a routerLink="/blog-details"><img src="assets/img/blog-image/blog3.jpg" alt="image"></a>
                    </div>
                    <div class="post-content">
                        <div class="post-meta">
                            <ul>
                                <li>By: <a routerLink="/">Steven Smith</a></li>
                                <li>June 25, 2019</li>
                            </ul>
                        </div>
                        <h3><a routerLink="/blog-details">How To Use Music To Boost Your Business</a></h3>
                        <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <a routerLink="/blog-details" class="read-more-btn">Read More <i class="flaticon-right-arrow"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
</section>
<!-- End Blog Area -->